export default __webpack_public_path__ + "static/media/icon_menu_bare_metal_servers_hover.d6a8989a.svg";